// app/javascript/controllers/calendar_controller.js
import { Controller } from "@hotwired/stimulus"
import { Calendar } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import interactionPlugin from '@fullcalendar/interaction'
//import * as bootstrap from "bootstrap"


export default class extends Controller {
  static targets = ["calendar","doctorSelect", "generateButton", "deleteButton"]

  connect() {
    console.log("FullCalendar Timeslots Stimulus controller connected")

    this.initializeSelect2()

    this.calendar = new Calendar(this.calendarTarget, {
      plugins: [ dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin ],
      initialView: 'dayGridMonth',
      slotDuration: '00:30:00',
      slotMinTime: '08:00:00',
      slotMaxTime: '17:00:00',
      headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,listWeek'
      },
      selectable: true,
      editable: false,
      eventClick: this.handleEventClick.bind(this),
      events: this.fetchEvents.bind(this)
    })

    this.calendar.render()
  }

  disconnect() {
    // Clean up Select2 when the controller is disconnected
    if (this.hasDoctorSelectTarget) {
      $(this.doctorSelectTarget).select2('destroy')
    }
  }
  
  fetchEvents(info, successCallback, failureCallback) {
    //const organizationId = this.data.get("organizationId")
    //const departmentId = this.data.get("departmentId")
    //const practitionerId = this.data.get("practitionerId")
    const doctorId = this.doctorSelectTarget ? this.doctorSelectTarget.value : 3;

    if (!doctorId) {
      // This is probably the first call and no practitioner is selected yet
      //doctorId=3
      return
    }

    console.log("Displaying information for ID: " + doctorId)

    //fetch(`/organizations/${organizationId}/departments/${departmentId}/practitioners/${practitionerId}/timeslots/calendar_events.json`)
    fetch(`/timeslots/available/practitioner/${doctorId}`)
    .then(response => response.json())
      .then(data => {
        const events = data.map(ts => ({
          id: ts.id,
          title: ts.title, //`${ts.start} - ${ts.end}`,
          start: ts.start,
          end: ts.end,
          //color: ts.status === 'blocked' ? 'red' : 'green',
          //backgroundColor: ts.status === 'blocked' ? 'red' : 'green',
          className: ts.status === 'free' ? 'text-success' : ts.status === 'booked' ? 'text-danger' : 'text-info' , 
          //url: ts.url
          url: `/timeslots/${ts.id}`
        }))
        successCallback(events)
      })
      .catch(error => {
        console.error("Error fetching timeslots:", error)
        failureCallback(error)
      })
  }

  handleEventClick(info) {
    info.jsEvent.preventDefault() // Prevent browser from following the link
    window.location.href = info.event.url // Navigate to the appointment edit page
    console.log("clicked eventd")

    // info.jsEvent.preventDefault(); // Prevent browser from following the link
    // const timeslotId = info.event.id; // Get the ID of the clicked timeslot
  
    // // Fetch the edit form for the clicked timeslot
    // fetch(`/timeslots/${timeslotId}/edit`, {
    //   method: 'GET', // Use GET method to fetch the edit form
    //   headers: {
    //     'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
    //     'Accept': 'text/html' // Indicate that we expect HTML response
    //   },
    //   //body: JSON.stringify({ data: { turbo_frame: "modal" } }) // Add turbo_frame data
    // })
    // .then(response => {
    //   if (!response.ok) throw new Error('Network response was not ok');
    //   return response.text(); // Get the HTML content
    // })
    // .then(data => {
    //   // Assuming you have a modal element with id 'myModal'
    //   const modalContent = document.querySelector('#myCustomModal .modal-body');
    //   modalContent.innerHTML = data; // Load the HTML into the modal body
    //   const modal = new bootstrap.Modal(document.getElementById('myCustomModal')); // Initialize Bootstrap modal
    //   modal.show(); // Show the modal
    // })
    // .catch(error => {
    //   console.error("Error fetching edit form:", error);
    //   this.showToast('error', 'Failed to load edit form.');
    // });

  }

  refresh(e) {
    if (e.detail.success) {
      this.calendar.refetchEvents();
    }
  }

  refreshEvents() {
    this.calendar.refetchEvents();
  }

  initializeSelect2() {
    if (this.hasDoctorSelectTarget) {
      $(this.doctorSelectTarget).select2({
        theme: 'bootstrap-5',
        width: '25%',
        // Add any other Select2 options you need
      }).on('select2:select select2:unselect', (e) => {
        this.refreshEvents()
      })
    }
  }

  showToast(type, message) {
    // Assuming you have a toast component or notification system
    // Adjust this according to your notification system
    const event = new CustomEvent('toast', {
      detail: { type, message }
    })
    window.dispatchEvent(event)
  }

  async generateTimeslots(event) {
    event.preventDefault()
    
    const doctorId = this.doctorSelectTarget.value
    if (!doctorId) {
      alert("Please select a doctor first")
      return
    }

    const button = event.currentTarget
    button.disabled = true
    button.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Generating...'

    try {
      const response = await fetch('/timeslots/generate', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify({ practitioner_id: doctorId })
      })

      if (!response.ok) throw new Error('Network response was not ok')

      const data = await response.json()
      if (data.success) {
        this.refreshEvents()
        this.showToast('success', 'Timeslots generated successfully!')
      } else {
        throw new Error(data.error || 'Failed to generate timeslots')
      }
    } catch (error) {
      console.error('Error:', error)
      this.showToast('error', error.message)
    } finally {
      button.disabled = false
      button.innerHTML = 'Generate Timeslots'
    }
  }
  
  async deleteTimeslots(event) {
    event.preventDefault()
    
    const doctorId = this.doctorSelectTarget.value
    if (!doctorId) {
      alert("Please select a doctor first")
      return
    }
    if (confirm("Are you sure you want to delete all free timeslots?")==false) {
      // If confirmed, proceed with the action
      return
    }

    const button = event.currentTarget
    button.disabled = true
    button.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Deleting...'

    try {
      const response = await fetch('/timeslots/delete_all', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify({ practitioner_id: doctorId })
      })

      if (!response.ok) throw new Error('Network response was not ok')

      const data = await response.json()
      if (data.success) {
        this.refreshEvents()
        this.showToast('success', 'Timeslots deleted successfully!')
      } else {
        throw new Error(data.error || 'Failed to delete timeslots')
      }
    } catch (error) {
      console.error('Error:', error)
      this.showToast('error', error.message)
    } finally {
      button.disabled = false
      button.innerHTML = 'Delete all timeslots'
    }
  }

}